
import { motion, MotionValue } from "motion/react";
import { LogoMark } from "./LogoMark";
import { WordMark } from "./WordMark";

export interface BrandProps {
  height: number | string;
  /**
   * CSS clip-path value for the reveal animation.
   * Can be a string or a MotionValue.
   * Default: 'inset(0 0 0 0)' (fully revealed)
   */
  clipPath?: string | MotionValue<string>;
  /**
   * Left position of the caret for the reveal animation.
   * Can be a string or a MotionValue.
   * Default: '110%' (end of text)
   */
  caretLeft?: string | MotionValue<string>;
  /**
   * Opacity of the caret.
   * Default: 1
   */
  caretOpacity?: number | MotionValue<number>;
  /**
   * Whether the caret (LogoMark) should flash like a cursor.
   * Default: false
   */
  flashing?: boolean;
  className?: string;
  style?: React.CSSProperties;
  color?: string | MotionValue<string>;
}

export function Brand({
  height,
  clipPath = "inset(0 0 0 0)",
  caretLeft = "110%",
  caretOpacity = 1,
  flashing = false,
  className,
  style,
  color,
}: BrandProps) {
  return (
    <motion.div className={`relative flex justify-center items-center ${className || ""}`} style={{ ...style, color: color as any }}>
      <motion.span className="inline-block overflow-hidden" style={{ clipPath }}>
        <WordMark height={height} />
      </motion.span>
      <motion.span
        className="absolute bottom-0 h-full -translate-x-1/2 z-5"
        style={{ left: caretLeft, opacity: caretOpacity }}
        animate={flashing ? { opacity: [1, 1, 0, 0] } : undefined}
        transition={
          flashing
            ? {
                duration: 1,
                repeat: Infinity,
                ease: "linear",
                times: [0, 0.5, 0.5, 1]
              }
            : undefined
        }
      >
        <LogoMark height={height} />
      </motion.span>
    </motion.div>
  );
}
